/**
 * Block password Verification Controller
 */
class BlockpasswordController {
    constructor(recoveryPasswordService, $scope, $uibModal, $state, $stateParams) {
        'ngInject';

        this.recoveryPasswordService = recoveryPasswordService;
        $scope.message = '';


        let result;
        let blockPasswordObj = {
            token: $stateParams.token,
            idPessoa: $stateParams.idPessoa,
            finalizouProcesso: $stateParams.finalizouProcesso
        }

        this.recoveryPasswordService.blockPassword(blockPasswordObj).then(e => {
            result = e;
            if(result.status == 200){
                $scope.$apply(function () {
                    $scope.message = "Sua senha foi bloqueada com sucesso!";
                });
            }else{
                $scope.$apply(function () {
                    $scope.message = "Senha expirada!"
                });
            }
        }).catch(error =>{
            $scope.$apply(function () {
                $scope.message = "Senha expirada!"
            });
        });
    }

    
}

export default BlockpasswordController;


// WEBPACK FOOTER //
// ./src/app/components/views/blockpassword/blockpassword.controller.js